<template>
  <div>
    <a-modal v-model:visible="visible" title="关联权限" @ok="handleOk" okText="确认" cancelText="取消" :afterClose="closeModal" width="55vw"  :cancelButtonProps="{ style: { display: 'none' }}">

      <div class="head">
        <span>名称</span>
        <roleSelector v-model="roleId" />
        <a-button @click="addToTable()">添加</a-button>
      </div>
      <a-table class="ant-table-striped" :columns="columns" :data-source="data" rowKey="id" :pagination="false" bordered>
        <template #title>
          <div class="thead">关联权限</div>
        </template>
        <template #operation="{ record }">
          <div class="flex_sa">

            <div class="editable-row-operations">
              <span>
                <a-popconfirm v-if="data.length" title="是否确认删除" @confirm="onDelete(record.id)" okText="确认" cancelText="取消">
                  <a>删除</a>
                </a-popconfirm>
              </span>
            </div>
          </div>
        </template>
      </a-table>
      <div style="text-align: center;margin-top: 20px;">
        <a-button type="primary" @click="visible2=true">新增角色</a-button>
      </div>
    </a-modal>
  </div>
  <!-- <addPrescription v-model="visible2" @getData="callbackData" /> -->
  <addRole v-model="visible2" />
</template>

<script>
import { reactive } from "vue";
import { Add, Search, Delete } from "/src/api/groupRole.js";
import roleSelector from '/src/components/selector/roleSelector.vue';
import addRole from '/src/components/role/addRole.vue';
export default {
  components: {
    roleSelector,
    addRole
  },
  data() {
    return {
      visible: this.modelValue,
      visible2: false,
      reload: false,
      medicineFilter: "",
      roleId: "",
      selectedRows: {},
      columns: [
        {
          title: "名称",
          key: "roleName",
          dataIndex: "roleName",
          width: "75%",
          slots: {
            customRender: "roleName"
          }
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "25%",
          slots: {
            customRender: "operation"
          }
        }
      ],
      data: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: {}
    },
  },
  computed: {
  },
  methods: {
    filter() {
      return true
    },
    async detail() {
      console.log(this.record);
      let res = await Search({ groupId: this.record.id })
      console.log(res);
      // console.log(res)
      if (res.errCode == 0) {
        this.data = res.data
      } else {
        this.$message.error("详情查询失败", function () { });
      }
    },
    async handleOk() {
      this.visible = false
    },
    async addToTable() {
      let obj = this.$store.state.roleList.find(item => item.id == this.roleId)
      console.log();
      console.log(obj);
      await Add({ roleId: obj.id, roleName: obj.name, groupId: this.record.id, groupName: this.record.name })
      this.roleId = ""
      this.detail()

    },
    async onDelete(id) {

      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      }


    },
    closeModal() {
      this.$emit('update:modelValue', false);
      //   if (this.reload) {
      //     this.$emit("reload")
      //   }
    },

  },
  watch: {
    record(val) {
      this.detail()
    },
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
</style>
